import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkTime } from '../../context/WorkTimeContext';
import { ActivitySelectionFilters } from '../../hooks/useActivityData';
import { IFilterOption } from '../../interface/transaction';

/**
 * The activity filter shared by the activity picker page and the activity dropdown. Until the user
 * picks one it follows the work time's matter, and the pick lasts for as long as the form is open.
 */
export const useActivityFilter = () => {
  const { t } = useTranslation();
  const { workTime, activityFilter, updateActivityFilter } = useWorkTime();
  const hasLinkedMatter = Boolean(workTime?.matter?.id);

  const filterOptions: IFilterOption[] = useMemo(
    () => [
      {
        label: t('worktime:activityFilters.allActivities'),
        value: ActivitySelectionFilters.ALL,
      },
      {
        label: t('worktime:activityFilters.matterLinkedActivities'),
        value: ActivitySelectionFilters.MATTER_ACTIVITIES,
      },
    ],
    [t],
  );
  const [allActivities, matterActivities] = filterOptions;

  const getSelectedFilter = () => {
    const picked = filterOptions.find(({ value }) => value === activityFilter?.value);
    if (!picked) return hasLinkedMatter ? matterActivities : allActivities;
    // The work time may have lost its matter since the pick, and there is nothing to link to then.
    return picked === matterActivities && !hasLinkedMatter ? allActivities : picked;
  };

  return {
    filterOptions,
    selectedFilter: getSelectedFilter(),
    selectFilter: updateActivityFilter,
    clearFilter: () => updateActivityFilter(allActivities),
  };
};
